// Map related
(function ($) {
  window.initMapBlock = function () {
    function parseLatLng(rawValue) {
      var split = rawValue.split(',');
      return {
        lat: parseFloat(split[0], 10),
        lng: parseFloat(split[1], 10)
      };
    }

    $('.js-map-block').each(function () {

      var mapElement = this;
      var startLocation = parseLatLng($(mapElement).data('place-geometry'));
      var placeId = ($(mapElement).data('place-id'));

      var map = new google.maps.Map(mapElement, {
        center: startLocation,
        zoom: 16,
        styles: [{
          stylers: [{
            saturation: -100
          }]
        }]
      });
      var service = new google.maps.places.PlacesService(map);
      getPlaceDetails(placeId, service);
      var marker = new google.maps.Marker({
        map: map,
        position: startLocation,
      });
    });

  };

  function getPlaceDetails(placeId, service) {
    var request = {
      placeId: placeId,
      fields: ['name', 'formatted_address', 'url']
    };
    service.getDetails(request, function () {
      $("p.placecard__info").text(arguments[0].formatted_address);
      $("p.placecard__business-name").text(arguments[0].name);
      $("#A_41").attr("href", arguments[0].url);
      console.log(arguments);
    });
  }
})(jQuery);